import { Observable, Subscribable, SubscribableOrNullableValue, SubscribableOrValue } from 'knockout';
import WCCEntity from 'models/entity';
import WCCError from 'models/wccError';

export interface CommunityNavigationWidgetItemConfig {
    Title?: SubscribableOrNullableValue<string>

    title?: SubscribableOrNullableValue<string>
    isRoot?: boolean
}

export default abstract class CommunityNavigationWidgetItemModel<T extends CommunityNavigationWidgetItemConfig = CommunityNavigationWidgetItemConfig> extends WCCEntity<T> {
    abstract toDoCount: Subscribable<number>

    demo = ko.observable(false);

    id: Subscribable<string>
    title: Observable<string>

    isContainer: Subscribable<boolean>
    isRoot: Observable<boolean>

    constructor(data?: T) {
        super();

        if (data != undefined)
            this.normalizeData(data);

        this.id = ko.pureComputed(() => this.getId());
        this.title = this.createField(<CommunityNavigationWidgetItemConfig>data, 'title', '');
        this.isContainer = ko.pureComputed(() => this.checkIfContainer());
        this.isRoot = ko.observable(data?.isRoot ?? false);
    }

    override toJson(forExport?: boolean) {
        return super.toJson();
    }

    canMergeWith(item: CommunityNavigationWidgetItemModel<T>) {
        return false;
    }

    mergeWith(item: CommunityNavigationWidgetItemModel<T>) {
        if (!this.canMergeWith(item))
            throw new WCCError(messages.InvalidRequest);
    }

    protected getId() {
        return 'item:' + this.title();
    }

    protected checkIfContainer() {
        return false;
    }

    protected normalizeData(data: T) {
        data.title ??= data.Title;
    }
}